import * as DialogPrimitive from '@radix-ui/react-dialog'
import { FC, PropsWithChildren } from 'react'
import { cn, Dialog, DialogContent, TDialogContent } from '@wellesley/ui'

export type CommonDialogProps = DialogPrimitive.DialogProps &
  TDialogContent & {
    testId?: string
    skipModalAutofocus?: boolean
  }

const handleDialogSkipAutoFocus = (event: Event) => {
  event.preventDefault()
}

const getModalAutoFocusProps = (skipAutofocus: boolean) =>
  skipAutofocus
    ? ({
        onOpenAutoFocus: handleDialogSkipAutoFocus,
        onCloseAutoFocus: handleDialogSkipAutoFocus,
      } as unknown as TDialogContent)
    : {}

const CommonDialog: FC<PropsWithChildren<CommonDialogProps>> = ({
  open,
  modal,
  children,
  onCloseModal,
  className,
  testId = 'common-dialog',
  skipModalAutofocus = false,
  closeOnOutsideClick = true,
  ...contentProps
}) => {
  // !!!! avoid to triggering hooks in modal when it is not open
  if (!open) return null

  return (
    <Dialog
      open={open}
      modal={modal}
      onOpenChange={(opened) => {
        if (!opened && closeOnOutsideClick) {
          onCloseModal?.()
        }
      }}
    >
      <DialogContent
        className={cn(className)}
        closeSize="small"
        data-testid={testId}
        closeVariant="insideCard"
        onCloseModal={onCloseModal}
        closeOnOutsideClick={closeOnOutsideClick}
        onInteractOutside={
          closeOnOutsideClick
            ? undefined
            : (event) => {
                event.preventDefault()
              }
        }
        onPointerDownOutside={
          closeOnOutsideClick
            ? undefined
            : (event) => {
                event.preventDefault()
              }
        }
        {...contentProps}
        {...getModalAutoFocusProps(skipModalAutofocus)}
        childrenClassName={cn(
          'overflow-auto',
          contentProps.title ? 'max-h-[calc(90vh-65px)]' : 'max-h-[90vh]',
          contentProps.childrenClassName,
        )}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}

export default CommonDialog
